export const 기계적요인 = [
  {
    content: "협착 위험(감김, 끼임)",
    isChecked: "",
  },
  {
    content: "위험한 표면(절단, 베임, 긁힘)",
    isChecked: "",
  },
  {
    content: "기계(설비)의 낙하, 비래, 전복, 붕괴, 전도 위험",
    isChecked: "",
  },
  {
    content: "충돌 위험",
    isChecked: "",
  },
  {
    content: "넘어짐 위험(미끄러짐, 걸림, 헛디딤)",
    isChecked: "",
  },
  {
    content: "추락 위험",
    isChecked: "",
  },
];

export const 전기적요인 = [
  {
    content: "감전(안전전압 초과)",
    isChecked: "",
  },
  {
    content: "아크",
    isChecked: "",
  },
  {
    content: "정전기",
    isChecked: "",
  },
  {
    content: "화재/폭발 위험",
    isChecked: "",
  },
];
export const 화학적요인 = [
  {
    content: "가스,증기,에어로졸,흄",
    isChecked: "",
  },
  {
    content: "액체,미스트,고체(분진)",
    isChecked: "",
  },
  {
    content: "반응성 물질, 방사선",
    isChecked: "",
  },
  {
    content: "화재/폭발 위험",
    isChecked: "",
  },
];
export const 생물학적요인 = [
  {
    content: "병원성 미생물, 바이러스에 의한 감염",
    isChecked: "",
  },
  {
    content: "유전자 변형물질",
    isChecked: "",
  },
  {
    content: "알러지 및 미생물",
    isChecked: "",
  },
  {
    content: "동물, 식물",
    isChecked: "",
  },
];
export const 작업특성요인 = [
  {
    content: "소음, 초음파, 초저주파음, 진동",
    isChecked: "",
  },
  {
    content: "종사자 실수(휴먼 에러)",
    isChecked: "",
  },
  {
    content: "저압 또는 고압상태, 질식 위험, 산소 결핍",
    isChecked: "",
  },
  {
    content: "중랑물 취급 작업, 반복 작업",
    isChecked: "",
  },
  {
    content: "불안정한 작업 자세, 작업(조작) 도구",
    isChecked: "",
  },
];
export const 작업환경요인 = [
  {
    content: "기후, 고온, 한랭",
    isChecked: "",
  },
  {
    content: "조명, 공간 및 이동통로",
    isChecked: "",
  },
  {
    content: "주변 종사자, 작업 시간",
    isChecked: "",
  },
  {
    content: "조직 안전문화",
    isChecked: "",
  },
  {
    content: "화상",
    isChecked: "",
  },
  {
    content: "작업(조작) 도구",
    isChecked: "",
  },
];
